export default {
  'mobileProfile.loremIpsum': 'لوريم إيبسوم',
  'mobileProfile.lastUpdated': 'آخر تحديث',
  'mobileProfile.next': 'التالي',
  'mobileProfile.contraryToPopular': 'مع تريبسي، سترى قريبًا العالم بأسره.',
  'mobileProfile.reverse': 'عكس',
  'mobileProfile.issued': 'صدر',
  'mobileProfile.search': 'بحث',
  'mobileProfile.myFavoriteTrips': 'رحلاتي المفضلة',
  'mobileProfile.newYork': 'نيويورك',
  'mobileProfile.losAngeles': 'لوس أنجلوس',
  'mobileProfile.toronto': 'تورونتو',
  'mobileProfile.lookToBook': 'البحث للحجز',
  'mobileProfile.grade': 'الدرجة',
  'mobileProfile.totalPoint': 'النقاط الكلية',
  'mobileProfile.activities': 'الأنشطة',
  'mobileProfile.salaryCard': 'بطاقة الراتب',
  'mobileProfile.weeks': 'أسابيع',
  'mobileProfile.searchTransaction': 'بحث عن عملية',
  'mobileProfile.march': 'مارس',
  'mobileProfile.receivedCashbook': 'سجل نقدي مستلم',
  'mobileProfile.transferedMoney': 'المال المحول',
  'mobileProfile.uber': 'أوبر',
  'mobileProfile.taxiService': 'خدمة التاكسي',
  'mobileProfile.morimoto': 'موريموتو',
  'mobileProfile.food&Drink': 'الطعام والشراب',
  'mobileProfile.receivedMoney': 'المال المستلم',
  'mobileProfile.fromRobertFox': 'من روبرت فوكس',
  'mobileProfile.spotifySubscr': 'اشتراك سبوتيفاي',
  'mobileProfile.expenses': 'المصاريف',
  'mobileProfile.subscription': 'الاشتراك',
};
